module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/step_background-a2a9ba54007b24c9aae69e40cee3d66d.svg";